// extracted by mini-css-extract-plugin
export default {"terms":"Terms-module__terms__8j10o","title":"Terms-module__title__59xUu","backButton":"Terms-module__backButton__Omzlo","backButtonContent":"Terms-module__backButtonContent__d6i2o"};